import Big from 'big.js'

interface SavePriceProps {
  originPrice: string
  finalPrice: string
}

const SavePrice = ({ originPrice, finalPrice }: SavePriceProps) => {
  return Big(originPrice).minus(finalPrice).toNumber() > 0 ? (
    <div className="absolute left-[10px] top-[10px] z-[1] rounded-[16px] border-[2px] border-white bg-[#DA291C] px-[4px] py-[4px] text-center max-xl:left-1 max-xl:top-1 max-xl:rounded-[10px] max-xl:border-[1px] max-xl:px-[1px] max-xl:pb-[1px] max-xl:pt-[3px]">
      <div className="mb-[2px] text-[17px] leading-[20px] text-white max-xl:text-xs">Ahorra</div>
      <div className="rounded-[20px] bg-white px-1 py-[2px] text-[17px] leading-[20px] text-[#DA291C] max-xl:rounded-full max-xl:px-[5px] max-xl:py-[2px] max-xl:text-xs">
        ${Big(originPrice).minus(finalPrice).toNumber()}
      </div>
    </div>
  ) : null
}

export default SavePrice
